export enum ModalTypeValue {
  Login = "Login",
  Register = "Register",
  ForgetPassword = "ForgetPassword",
  ChangePassword = "change-password",
  ChangeLanguage = "change-language",
  Bank = "Bank",
  Download = "Download",
  Message = "Message",
  Affiliate = "Affiliate",
  Close = ""
}
export interface ModalType {
  openModal: ModalTypeValue;
  openSidebar: boolean;
  isOpenChat: boolean;
}
